import chroma from 'chroma-js';

const black = chroma(0, 0, 0);
const white = chroma(255, 255, 255);
const primary = chroma(32, 147, 153);
const warning = chroma(249, 203, 64);
const danger = chroma(255, 113, 91);
const newColor = 'black';

const color = {
  // Base
  black,
  blackLighter: black.brighten(),
  blackLightest: black.brighten(5),

  white,
  whiteDark: white.darken(0.25),
  whiteDarker: white.darken(0.5),

  // Theme
  primary,
  primaryWhitened: primary.brighten(3.7),
  primaryLightest: primary.brighten(0.5),
  primaryLighter: primary.brighten(0.25),
  primaryDarker: primary.darken(),
  primaryDarkest: primary.darken(1.5),

  warning,

  danger,

  hover: '#fafbfe',
  accent: primary,
  text: '#646777',

  background: '#f2f4f7',

  // Layout
  topbar: {
    background: white,
  },
  sidebar: {
    background: white,
    linkText: black,
  },

  // Misc
  border: '#dee2e6',
};

export default color;
